import styled from 'styled-components'
import { darken } from 'polished'

const SocialContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(135px, 1fr));
  grid-gap: 10px;
`

const SocialWrapper = styled.a`
  width: 100%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.color.text1};
  text-decoration: none;
  background: ${({ brand, theme }) => theme.brands[brand] || 'none'};
  padding: 10px;
  transition: all 0.3s ease-in-out;
  box-shadow: inset 0 0 0 2px
    ${({ brand, theme }) => (brand ? darken(0.2, theme.brands[brand]) : 'none')};

  &:hover {
    background: ${({ brand, theme }) =>
      brand ? darken(0.2, theme.brands[brand]) : 'none'};
    box-shadow: inset 0 0 0 2px
      ${({ brand, theme }) => theme.brands[brand] || 'none'};
  }
`

const SocialTitle = styled.span`
  font-weight: bold;
  margin-left: 5px;
`

export { SocialContainer, SocialWrapper, SocialTitle }
